module.exports = __webpack_public_path__ + "static/media/mobile04.2fefbb76.jpg";